<template>
  <div class="gritcode-wizard">
    <slot></slot>
  </div>
</template>

<script>
import './wizard.css'

export default {
  replace: true,
  props: {
    currentIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      countItems: 0
    }
  },
  methods: {
    changeCurrentIndex (index) {
      // change currentIndex
      // if previous step is valid
      // if previousDisabled is not set on the current step
      if (this.$children[this.currentIndex].disablePrevious && this.currentIndex > index) return false
      if (this.$children[index - 1] && this.$children[index - 1].valid || index < this.currentIndex) {
        this.currentIndex = index
        return true
      }
      return false
    }
  },
  ready () {
    // get all steps
    this.countItems = this.$children.length
    // set index for each wiard-step component
    this.$children.forEach((item, index) => {
      item.index = index
    })
  }
}
</script>


// WEBPACK FOOTER //
// wizard.vue?edc9a388